import api from "./api";

export const deleteCourt = async (id) => {
  return api
    .delete({
      port: process.env.REACT_APP_PORT_COURT,
      endpoint: `/own/court/${id}`,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
